import React from "react";
import css from './FloatingWindow.css'
import PropTypes from 'prop-types';

export default function FloatingWindow(props) {

  return <div>
          <div className={[props.show === false ? css.hidden : "",css.backDrop].join(" ")} onClick={props.closeWindowAction}></div>
          <div className={[props.show === false ? css.hidden : "", css.container].join(" ")}>
            <div className={[css.header, "col row col-12 "].join(" ")}>
              <div className={[css.btn_close, "col-1 offset-11"].join(" ")}>
                <button onClick={props.closeWindowAction} onKeyDown={props.closeWindowAction}>
                  <i className="fa fa-2x fa-window-close"/>
                </button>
              </div>
            </div>
            {props.content}
          </div>
        </div>
}

FloatingWindow.propTypes = {
    show: PropTypes.bool,
    content: PropTypes.string,
    closeWindowAction: PropTypes.func
}
